import React from 'react'
import { Header } from 'src/components'
import { st } from 'src/locales/TranslationHelper'

export const NotFoundRoute: React.FC = () => <Header title='404' subtitle={st.errors.pageNotFound()} />
